import { deClientPortalValuationOverviewPageCommon } from './ValuationOverview/ValuationOverview'

export const deClientPortalValuationOverviewCommon = {
    valuationOverview: deClientPortalValuationOverviewPageCommon,
}
